export default "__VITE_ASSET__55a1a287__"